export function base64ToBinary(base64String: string) {
  return Uint8Array.from(
    window.atob(base64String.replace(/^data:image\/\w+;base64,/, '')),
    (c) => c.charCodeAt(0),
  );
}
